import React from 'react'
import styled from '@emotion/styled'
import { useNavigate } from '@tanstack/react-router'

import { Button } from '@/components/Button'
import { Flex } from '@/components/Flex'
import { colors } from '@/constants/colors'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 2rem;
`

const Title = styled.h1`
  font-size: 4rem;
  font-weight: bold;
  color: ${colors.blue};
  margin: 0 0 1rem 0;
`

const Subtitle = styled.h2`
  font-size: 1.5rem;
  color: ${colors.grey500};
  margin: 0 0 1rem 0;
`

const Message = styled.p`
  font-size: 1rem;
  color: ${colors.grey400};
  margin: 0 0 2rem 0;
  max-width: 400px;
`

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate({ to: '/' })
  }

  const handleGoBack = () => {
    window.history.back()
  }

  return (
    <Container>
      <Title>404</Title>
      <Subtitle>Page Not Found</Subtitle>
      <Message>
        The page you are looking for might have been removed, 
        had its name changed, or is temporarily unavailable.
      </Message>
      
      <Flex gap="1rem" flexDirection="row">
        <Button 
          type="button" 
          onClick={handleGoBack}
          style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
        >
          Go Back
        </Button>
        <Button 
          type="button" 
          onClick={handleGoHome}
          color="blue"
          style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
        >
          Go Home
        </Button>
      </Flex>
    </Container>
  )
}
